module.exports = __webpack_public_path__ + "static/stackblitz-30b783fede12c7b936bb04fb51ab3f20.svg";